import React, { useState, useEffect } from 'react'
import { useSelector } from "react-redux";
import { templatesSelector } from "slices/templateSlice";
import moment from 'moment';
import { fetchTemplates } from 'slices/templateSlice';
import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { TimeInput } from 'components/template/TemplateForm';
import { RateInput } from 'components/template/TemplateForm';
import { UnitSelect } from 'components/template/TemplateForm';
import { Select } from 'components/common/Select';
import { filterIncremental } from 'components/template/TemplateForm';

const LanguageTiers = ({ subject, subjectIndex, control, errors, item, dispatch, setValue, watch, error, sendClientData, deletedSubjects = [] }) => {
    const { templates } = useSelector(templatesSelector);
    const [changeTemplate, setChangeTemplate] = useState();

    const handleNormalHoursChange = () => {
        // const normalHourStartTime = watch("normal_hour_start_time");
        const normalHourStartTime = watch(`subjectConfigs.${subjectIndex}.normal_hour_start_time`);
        // const normalHourEndTime = watch("normal_hour_end_time");
        const normalHourEndTime = watch(`subjectConfigs.${subjectIndex}.normal_hour_end_time`);

        if (normalHourStartTime && normalHourEndTime) {
            const normalStart = moment(normalHourStartTime, "HH:mm");
            const normalEnd = moment(normalHourEndTime, "HH:mm");

            const afterStart = moment(normalEnd).add(1, "minutes");
            const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

            setValue("after_hour_start_time", afterStart.format("HH:mm"));
            setValue("after_hour_end_time", afterEnd.format("HH:mm"));
        }
    };

    useEffect(() => {
        setChangeTemplate(undefined);
    }, [subject]);

    const handleAfterHoursChange = () => {
        // const afterHourStartTime = watch("after_hour_start_time");
        const afterHourStartTime = watch(`subjectConfigs.${subjectIndex}.after_hour_start_time`);
        // const afterHourEndTime = watch("after_hour_end_time");
        const afterHourEndTime = watch(`subjectConfigs.${subjectIndex}.after_hour_end_time`);

        if (afterHourStartTime && afterHourEndTime) {
            const afterStart = moment(afterHourStartTime, "HH:mm");
            const afterEnd = moment(afterHourEndTime, "HH:mm");

            const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
            const normalEnd = moment(afterStart).subtract(1, "minutes");

            setValue("normal_hour_start_time", normalStart.format("HH:mm"));
            setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
        }
    };

    const handleChangeMinDuration = (value) => {
        let activeTiers = [];
        if (changeTemplate?.interpretation_rates) {
            activeTiers = changeTemplate.interpretation_rates;
        } else if (item?.interpretation_rates) {
            activeTiers = item.interpretation_rates.filter(r => r.subject === subject);
        } else if (selectedTemplate?.interpretation_rates) {
            activeTiers = selectedTemplate.interpretation_rates;
        }

        const timeUnit = (value === "minute" || value === "30_minute") ? 'minute' : 'hour';

        activeTiers.forEach((_, index) => {
            const basePath = `subjectConfigs.${subjectIndex}.interpretationRates`;
            setValue(`${basePath}.opi_normal_mins_time_unit.${index}`, timeUnit);
            setValue(`${basePath}.vri_normal_mins_time_unit.${index}`, timeUnit);
            setValue(`${basePath}.inperson_normal_mins_time_unit.${index}`, timeUnit);
            setValue(`${basePath}.opi_after_mins_time_unit.${index}`, timeUnit);
            setValue(`${basePath}.vri_after_mins_time_unit.${index}`, timeUnit);
            setValue(`${basePath}.inperson_after_mins_time_unit.${index}`, timeUnit);
        });
    }

    // #region template dropdown
    // const [filterTemplate, setfilterTemplates] = useState({
    //     label: "",
    //     value: ""
    // })
    const [filterTemplate, setfilterTemplates] = useState(null)

    // useEffect(() => {
    //     if (item?.client_template?.name && item?.client_template?.id) {
    //         setfilterTemplates({
    //             label: item?.client_template?.name || "",
    //             value: item?.client_template?.id || ""
    //         })
    //     } else {
    //         setfilterTemplates(null)
    //     }
    // }, [item?.client_template])

    const filteredTemplateLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchTemplates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue, type: "interpretation" }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    const selectedTemplate = templates?.find((i => i.id === filterTemplate?.value))

    // useEffect(() => {
    //     if (changeTemplate) {
    //         sendClientData(changeTemplate?.interpretation_rates?.map(i => i?.tier_id))
    //     } else if (item?.interpretation_rates) {
    //         sendClientData(item?.interpretation_rates?.map(i => i?.client_tier_id))
    //     } else {
    //         sendClientData(selectedTemplate?.interpretation_rates?.map(i => i?.tier_id))
    //     }
    // }, [selectedTemplate, item?.interpretation_rates, changeTemplate])

    // useEffect(() => {
    //     if (changeTemplate) {
    //         sendClientData(
    //             changeTemplate?.interpretation_rates?.map(i => ({
    //                 tier_id: i.tier_id,
    //                 subject,
    //                 subjectIndex,
    //             }))
    //         );
    //     }
    //     else if (item?.interpretation_rates) {
    //         // Filter rates for current subject
    //         const subjectRates = item.interpretation_rates.filter(r => r.subject === subject);
    //         sendClientData(
    //             subjectRates.map(i => ({
    //                 tier_id: i.client_tier_id,
    //                 subject,
    //                 subjectIndex,
    //             }))
    //         );
    //     }
    //     else {
    //         sendClientData(
    //             selectedTemplate?.interpretation_rates?.map(i => ({
    //                 tier_id: i.tier_id,
    //                 subject,
    //                 subjectIndex,
    //             }))
    //         );
    //     }
    // }, [selectedTemplate, item?.interpretation_rates, changeTemplate, subject]);

    useEffect(() => {
        const isReAdded = deletedSubjects.includes(subject?.value || subject);
        
        if (changeTemplate) {
            sendClientData(
                changeTemplate?.interpretation_rates?.map(i => ({
                    tier_id: i.tier_id,
                    subject,
                    subjectIndex,
                }))
            );
        }
        else if (item?.interpretation_rates && !isReAdded) {  // <-- isReAdded check
            const subjectRates = item.interpretation_rates.filter(r => r.subject === subject);
            sendClientData(
                subjectRates.map(i => ({
                    tier_id: i.client_tier_id,
                    subject,
                    subjectIndex,
                }))
            );
        }
        else {
            sendClientData(
                selectedTemplate?.interpretation_rates?.map(i => ({
                    tier_id: i.tier_id,
                    subject,
                    subjectIndex,
                }))
            );
        }
    }, [selectedTemplate, item?.interpretation_rates, changeTemplate, subject, deletedSubjects]);

    useEffect(() => {
        // setValue('normal_hour_start_time', (item || selectedTemplate)?.normal_hour_start_time || '')
        // setValue('normal_hour_end_time', (item || selectedTemplate)?.normal_hour_end_time || '')
        // setValue('after_hour_start_time', (item || selectedTemplate)?.after_hour_start_time || '')
        // setValue('after_hour_end_time', (item || selectedTemplate)?.after_hour_end_time || '')
        // setValue('grace_period', (item || selectedTemplate)?.grace_period || 0)
        // setValue('incremental', (item || selectedTemplate)?.incremental || '')
        // setValue('rush_fee', (item || selectedTemplate)?.rush_fee || 0)
        setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, (item || selectedTemplate)?.normal_hour_start_time || '', { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, (item || selectedTemplate)?.normal_hour_end_time || '', { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, (item || selectedTemplate)?.after_hour_start_time || '', { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, (item || selectedTemplate)?.after_hour_end_time || '', { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.grace_period`, (item || selectedTemplate)?.grace_period || 0, { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.incremental`, (item || selectedTemplate)?.incremental || '', { shouldValidate: true })
        setValue(`subjectConfigs.${subjectIndex}.rush_fee`, (item || selectedTemplate)?.rush_fee || 0, { shouldValidate: true })

        const basePath = `subjectConfigs.${subjectIndex}.interpretationRates`;

        let activeRates = [];
        if (item?.interpretation_rates) {
            activeRates = item.interpretation_rates.filter(r => r.subject === subject);
        } else if (selectedTemplate?.interpretation_rates) {
            activeRates = selectedTemplate.interpretation_rates;
        }

        // Helper to simplify setting values
        const setRateValue = (field, sourceField) => {
            // setValue(`${basePath}.${field}`, activeRates.map(rate => rate[sourceField]) || '');
            activeRates.forEach((rate, index) => {
                setValue(`${basePath}.${field}.${index}`, rate[sourceField], { shouldValidate: true });
            });
        };
        const setRateTimeUnit = (field, sourceField) => {
            // setValue(`${basePath}.${field}`, activeRates.map(rate => rate[sourceField]) || ['hour']);
            activeRates.forEach((rate, index) => {
                setValue(`${basePath}.${field}.${index}`, rate[sourceField] || (field.includes('mins') ? 'minute' : 'hour'), { shouldValidate: true });
            });
        };

        setRateValue('opi_normal_rate', 'opi_normal_rate');
        setRateValue('vri_normal_rate', 'vri_normal_rate');
        setRateValue('inperson_normal_rate', 'inperson_normal_rate');

        setRateTimeUnit('opi_normal_rate_time_unit', 'opi_normal_rate_time_unit');
        setRateTimeUnit('vri_normal_rate_time_unit', 'vri_normal_rate_time_unit');
        setRateTimeUnit('inperson_normal_time_unit', 'inperson_normal_time_unit');

        setRateValue('opi_normal_mins', 'opi_normal_mins');
        setRateValue('vri_normal_mins', 'vri_normal_mins');
        setRateValue('inperson_normal_mins', 'inperson_normal_mins');

        setRateTimeUnit('opi_normal_mins_time_unit', 'opi_normal_mins_time_unit');
        setRateTimeUnit('vri_normal_mins_time_unit', 'vri_normal_mins_time_unit');
        setRateTimeUnit('inperson_normal_mins_time_unit', 'inperson_normal_mins_time_unit');

        setRateValue('opi_after_rate', 'opi_after_rate');
        setRateValue('vri_after_rate', 'vri_after_rate');
        setRateValue('inperson_after_rate', 'inperson_after_rate');

        setRateTimeUnit('opi_after_rate_time_unit', 'opi_after_rate_time_unit');
        setRateTimeUnit('vri_after_rate_time_unit', 'vri_after_rate_time_unit');
        setRateTimeUnit('inperson_after_time_unit', 'inperson_after_time_unit');

        setRateValue('opi_after_mins', 'opi_after_mins');
        setRateValue('vri_after_mins', 'vri_after_mins');
        setRateValue('inperson_after_mins', 'inperson_after_mins');

        setRateTimeUnit('opi_after_mins_time_unit', 'opi_after_mins_time_unit');
        setRateTimeUnit('vri_after_mins_time_unit', 'vri_after_mins_time_unit');
        setRateTimeUnit('inperson_after_mins_time_unit', 'inperson_after_mins_time_unit');

        if (item?.client_template) {
            setValue(`subjectConfigs.${subjectIndex}.client_template_id`, item?.client_template?.id || '')
        }
    }, [item, subjectIndex, subject]);

    // useEffect(() => {
    //     console.log('languageitemsss', item);
    //     // const config = item?.subjectConfigs?.[subjectIndex];
    //     const config = item?.subclient_type_rates?.find(r => r.subject === subject);
    //     if (config) {
    //         // Prefill template dropdown
    //         const clientTemplate = templates?.find(t => t.id === config.client_template_id);
    //         // setfilterTemplates(clientTemplate ? { label: clientTemplate.name, value: clientTemplate.id } : null);
    //         if (clientTemplate) {
    //             setfilterTemplates({ label: clientTemplate.name, value: clientTemplate.id });
    //         } else if (config.client_template_id) {
    //             // If not found in loaded samples, try config's own template object or item's template
    //             if (config.client_template?.name) {
    //                 setfilterTemplates({ label: config.client_template.name, value: config.client_template.id });
    //             } else if (item?.client_template?.id === config.client_template_id) {
    //                 setfilterTemplates({ label: item.client_template.name, value: item.client_template.id });
    //             } else {
    //                 setfilterTemplates({ label: "Loading Template...", value: config.client_template_id });
    //             }
    //         } else {
    //             setfilterTemplates(null);
    //         }
    //         setValue(`subjectConfigs.${subjectIndex}.client_template_id`, config.client_template_id);

    //         // Prefill hours
    //         setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, config.normal_hour_start_time || '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, config.normal_hour_end_time || '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, config.after_hour_start_time || '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, config.after_hour_end_time || '', { shouldValidate: true });

    //         // Prefill fees & options
    //         setValue(`subjectConfigs.${subjectIndex}.grace_period`, config.grace_period || 0, { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.incremental`, config.incremental || '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.rush_fee`, config.rush_fee || 0, { shouldValidate: true });
    //     } else {
    //         // Clear fields if this subject has no saved config (e.g. newly added subject)
    //         setfilterTemplates(null);
    //         setValue(`subjectConfigs.${subjectIndex}.client_template_id`, '');
    //         setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.grace_period`, 0, { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.incremental`, '', { shouldValidate: true });
    //         setValue(`subjectConfigs.${subjectIndex}.rush_fee`, 0, { shouldValidate: true });
    //     }
    // }, [item, templates, subjectIndex, subject]);

    useEffect(() => {
    console.log('languageitemsss', item);
    const config = item?.subclient_type_rates?.find(r => r.subject === subject);
    
    const isReAdded = deletedSubjects.includes(subject?.value || subject);
    
    if (config && !isReAdded) {
        const clientTemplate = templates?.find(t => t.id === config.client_template_id);
        if (clientTemplate) {
            setfilterTemplates({ label: clientTemplate.name, value: clientTemplate.id });
        } else if (config.client_template_id) {
            if (config.client_template?.name) {
                setfilterTemplates({ label: config.client_template.name, value: config.client_template.id });
            } else if (item?.client_template?.id === config.client_template_id) {
                setfilterTemplates({ label: item.client_template.name, value: item.client_template.id });
            } else {
                setfilterTemplates({ label: "Loading Template...", value: config.client_template_id });
            }
        } else {
            setfilterTemplates(null);
        }
        setValue(`subjectConfigs.${subjectIndex}.client_template_id`, config.client_template_id);
        setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, config.normal_hour_start_time || '', { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, config.normal_hour_end_time || '', { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, config.after_hour_start_time || '', { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, config.after_hour_end_time || '', { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.grace_period`, config.grace_period || 0, { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.incremental`, config.incremental || '', { shouldValidate: true });
        setValue(`subjectConfigs.${subjectIndex}.rush_fee`, config.rush_fee || 0, { shouldValidate: true });
    } else {
        // setfilterTemplates(null);
        // setValue(`subjectConfigs.${subjectIndex}.client_template_id`, '');
        // setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, '', { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, '', { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, '', { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, '', { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.grace_period`, 0, { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.incremental`, '', { shouldValidate: true });
        // setValue(`subjectConfigs.${subjectIndex}.rush_fee`, 0, { shouldValidate: true });
    }
    }, [item, templates, subjectIndex, subject, deletedSubjects]);
    

    const handleChangeTemplate = (filterTemplateObj) => {
        if (filterTemplateObj?.value) {
            const newTemplate = templates?.find(i => i.id === filterTemplateObj.value);
            setChangeTemplate(newTemplate);
            // setValue('normal_hour_start_time', newTemplate?.normal_hour_start_time || '')
            // setValue('normal_hour_end_time', newTemplate?.normal_hour_end_time || '')
            // setValue('after_hour_start_time', newTemplate?.after_hour_start_time || '')
            // setValue('after_hour_end_time', newTemplate?.after_hour_end_time || '')
            // setValue('grace_period', newTemplate?.grace_period || 0)
            // setValue('incremental', newTemplate?.incremental || '')
            // setValue('rush_fee', newTemplate?.rush_fee || 0)
            setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, newTemplate?.normal_hour_start_time || '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, newTemplate?.normal_hour_end_time || '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, newTemplate?.after_hour_start_time || '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, newTemplate?.after_hour_end_time || '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.grace_period`, newTemplate?.grace_period || 0, { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.incremental`, newTemplate?.incremental || '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.rush_fee`, newTemplate?.rush_fee || 0, { shouldValidate: true })

            const basePath = `subjectConfigs.${subjectIndex}.interpretationRates`;
            const setRateValue = (field, sourceField) => {
                // setValue(`${basePath}.${field}`, newTemplate?.interpretation_rates?.map(rate => rate[sourceField]) || '');
                newTemplate?.interpretation_rates?.forEach((rate, index) => {
                    setValue(`${basePath}.${field}.${index}`, rate[sourceField], { shouldValidate: true });
                });
            };
            const setRateTimeUnit = (field, sourceField) => {
                // (`${basePath}.${field}`, newTemplate?.interpretation_rates?.map(rate => rate[sourceField]) || ['hour']);
                newTemplate?.interpretation_rates?.forEach((rate, index) => {
                    setValue(`${basePath}.${field}.${index}`, rate[sourceField] || (field.includes('mins') ? 'minute' : 'hour'), { shouldValidate: true });
                });
            };

            setRateValue('opi_normal_rate', 'opi_normal_rate');
            setRateValue('vri_normal_rate', 'vri_normal_rate');
            setRateValue('inperson_normal_rate', 'inperson_normal_rate');

            setRateTimeUnit('opi_normal_rate_time_unit', 'opi_normal_rate_time_unit');
            setRateTimeUnit('vri_normal_rate_time_unit', 'vri_normal_rate_time_unit');
            setRateTimeUnit('inperson_normal_time_unit', 'inperson_normal_time_unit');

            setRateValue('opi_normal_mins', 'opi_normal_mins');
            setRateValue('vri_normal_mins', 'vri_normal_mins');
            setRateValue('inperson_normal_mins', 'inperson_normal_mins');

            setRateTimeUnit('opi_normal_mins_time_unit', 'opi_normal_mins_time_unit');
            setRateTimeUnit('vri_normal_mins_time_unit', 'vri_normal_mins_time_unit');
            setRateTimeUnit('inperson_normal_mins_time_unit', 'inperson_normal_mins_time_unit');

            setRateValue('opi_after_rate', 'opi_after_rate');
            setRateValue('vri_after_rate', 'vri_after_rate');
            setRateValue('inperson_after_rate', 'inperson_after_rate');

            setRateTimeUnit('opi_after_rate_time_unit', 'opi_after_rate_time_unit');
            setRateTimeUnit('vri_after_rate_time_unit', 'vri_after_rate_time_unit');
            setRateTimeUnit('inperson_after_time_unit', 'inperson_after_time_unit');

            setRateValue('opi_after_mins', 'opi_after_mins');
            setRateValue('vri_after_mins', 'vri_after_mins');
            setRateValue('inperson_after_mins', 'inperson_after_mins');

            setRateTimeUnit('opi_after_mins_time_unit', 'opi_after_mins_time_unit');
            setRateTimeUnit('vri_after_mins_time_unit', 'vri_after_mins_time_unit');
            setRateTimeUnit('inperson_after_mins_time_unit', 'inperson_after_mins_time_unit');

            // setValue('client_template_id', newTemplate?.id || '')
        }
        else {
            setChangeTemplate(undefined);
            const basePath = `subjectConfigs.${subjectIndex}.interpretationRates`;
            const clearRate = (field) => setValue(`${basePath}.${field}`, '');
            const clearTimeUnit = (field) => setValue(`${basePath}.${field}`, ['hour']);

            clearRate('opi_normal_rate');
            clearRate('vri_normal_rate');
            clearRate('inperson_normal_rate');
            clearTimeUnit('opi_normal_rate_time_unit');
            clearTimeUnit('vri_normal_rate_time_unit');
            clearTimeUnit('inperson_normal_time_unit');
            clearRate('opi_normal_mins');
            clearRate('vri_normal_mins');
            clearRate('inperson_normal_mins');
            clearTimeUnit('opi_normal_mins_time_unit');
            clearTimeUnit('vri_normal_mins_time_unit');
            clearTimeUnit('inperson_normal_mins_time_unit');

            clearRate('opi_after_rate');
            clearRate('vri_after_rate');
            clearRate('inperson_after_rate');
            clearTimeUnit('opi_after_rate_time_unit');
            clearTimeUnit('vri_after_rate_time_unit');
            clearTimeUnit('inperson_after_time_unit');
            clearRate('opi_after_mins');
            clearRate('vri_after_mins');
            clearRate('inperson_after_mins');
            clearTimeUnit('opi_after_mins_time_unit');
            clearTimeUnit('vri_after_mins_time_unit');
            clearTimeUnit('inperson_after_mins_time_unit');

            setValue(`subjectConfigs.${subjectIndex}.normal_hour_start_time`, '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.normal_hour_end_time`, '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.after_hour_start_time`, '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.after_hour_end_time`, '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.grace_period`, 0, { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.incremental`, '', { shouldValidate: true })
            setValue(`subjectConfigs.${subjectIndex}.rush_fee`, 0, { shouldValidate: true })
        }
    }
    console.log(filterTemplate, "selectedTemplate", templates, item);

    return (
        <>
            <div className="row-primary inter_rates w-50">
                <h2>Interpretation Rates Template *</h2>
                <div className='w-100'>
                    <Controller
                        // name="client_template_id"
                        name={`subjectConfigs.${subjectIndex}.client_template_id`}
                        control={control}
                        rules={{
                            required: "Please select a template"
                        }}
                        render={({ field }) =>
                            <div style={{ width: "100%" }}>
                                {console.log("filterTemplate", field.value)}
                                <AsyncPaginate
                                    menuPlacement='auto'
                                    styles={{
                                        ...selectCustomStyles,
                                    }}
                                    value={filterTemplate}
                                    loadOptions={filteredTemplateLoadOptions}
                                    isClearable={false}
                                    escapeClearsValue
                                    onChange={(obj) => {
                                        if (obj?.value) {
                                            setfilterTemplates(obj)
                                            field.onChange(obj.value);
                                            handleChangeTemplate(obj)
                                        }
                                        else {
                                            setfilterTemplates(null)
                                            field.onChange(null);
                                            handleChangeTemplate(null)
                                        }
                                    }}
                                    additional={{
                                        page: item?.state?.id ? 2 : 1,
                                    }}
                                />
                                {errors?.subjectConfigs?.[subjectIndex]?.client_template_id?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.subjectConfigs?.[subjectIndex]?.client_template_id?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>
            {/* {(changeTemplate || item?.interpretation_rates?.length > 0) */}
            {/* {(changeTemplate || item?.interpretation_rates?.filter(r => r.subject === subject)?.length > 0 || selectedTemplate) */}
            {(() => {
                const isReAdded = deletedSubjects.includes(subject?.value || subject);
                return (
                    changeTemplate ||
                    (!isReAdded && item?.interpretation_rates?.filter(r => r.subject === subject)?.length > 0) ||
                    selectedTemplate
                );
            })()
                &&
                <>
                    {/* Normal Hours */}
                    <div className="row-primary m-0 row-r justify-content-between flex-row">
                        <h2 className='fst-italic fw-bold mt-0'>Normal Hours </h2>
                    </div>
                    <div className="foam_page_row">
                        <div className="row-primary">
                            <h2>Start Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                // name="normal_hour_start_time"
                                name={`subjectConfigs.${subjectIndex}.normal_hour_start_time`}
                                rule="Please select start time"
                                onChange={handleNormalHoursChange}
                            />
                        </div>

                        <div className="row-primary">
                            <h2>End Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                // name="normal_hour_end_time"
                                name={`subjectConfigs.${subjectIndex}.normal_hour_end_time`}
                                rule="Please select End time"
                                onChange={handleNormalHoursChange}
                            />
                        </div>
                    </div>

                    {/* After Hours */}
                    <div className="row-primary m-0 row-r justify-content-between flex-row">
                        <h2 className='fst-italic fw-bold mt-0'>After Hours </h2>
                    </div>
                    <div className="foam_page_row">
                        <div className="row-primary">
                            <h2>Start Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                // name="after_hour_start_time"
                                name={`subjectConfigs.${subjectIndex}.after_hour_start_time`}
                                rule="Please select start time"
                                onChange={handleAfterHoursChange}
                            />
                        </div>

                        <div className="row-primary">
                            <h2>End Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                // name="after_hour_end_time"
                                name={`subjectConfigs.${subjectIndex}.after_hour_end_time`}
                                rule="Please select End time"
                                onChange={handleAfterHoursChange}
                            />
                        </div>
                    </div>


                    {/* Grace Period */}
                    <div className='foam_page_row mt-3'>
                        <div className="row-primary">
                            <h2>Cancellation Grace Period(Hrs) *</h2>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    // name="grace_period"
                                    name={`subjectConfigs.${subjectIndex}.grace_period`}
                                    control={control}
                                    rules={{ required: "Please enter Grace Period" }}
                                    render={({ field }) => (
                                        <input className="input-in type_inp"
                                            type="number"
                                            name='grace_period'
                                            placeholder='Grace Period' required
                                            {...field}
                                            onChange={
                                                (e) => {
                                                    field.onChange(parseFloat(e.target.value));
                                                    if (e.target.value < 0) {
                                                        field.onChange(0);
                                                    }
                                                }
                                            }
                                        />
                                    )}
                                />
                                {errors?.grace_period?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.grace_period?.message} /></div>}
                            </div>
                        </div>

                        <div className="row-primary">
                            <h2>Incremental *</h2>
                            <Controller
                                // name="incremental"
                                name={`subjectConfigs.${subjectIndex}.incremental`}
                                control={control}
                                render={({ field }) =>
                                    <div className='select_box' style={{ width: "100%" }}>
                                        <Select
                                            name="incremental"
                                            options={filterIncremental || []}
                                            value={field.value ? filterIncremental?.find((opt) => field.value == opt.value) : ""}
                                            isClearable={false}
                                            disabledSearch={true}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                handleChangeMinDuration(value)
                                            }}
                                        />
                                    </div>
                                }
                            />
                        </div>
                    </div>

                    {/* Rush Fee  */}
                    <div className='foam_page_row mt-3'>
                        <div className="row-primary">
                            <h2>Rush Fee *</h2>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    // name="rush_fee"
                                    name={`subjectConfigs.${subjectIndex}.rush_fee`}
                                    control={control}
                                    rules={{ required: "Please enter rush fee" }}
                                    render={({ field }) => (
                                        <input className="input-in type_inp" type="number"
                                            name='rush_fee'
                                            placeholder='Rush fee' {...field}
                                            onChange={
                                                (e) => {
                                                    field.onChange(parseFloat(e.target.value));
                                                    if (e.target.value < 0) {
                                                        field.onChange(0);
                                                    }
                                                }
                                            }
                                            required
                                        />
                                    )}
                                />
                                {errors?.rush_fee?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.rush_fee?.message} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </>
            }
            {/* {(changeTemplate || item || selectedTemplate) &&
                (() => {
                    let activeRates = [];
                    if (changeTemplate?.interpretation_rates) {
                        activeRates = changeTemplate.interpretation_rates;
                    } else if (item?.interpretation_rates) {
                        activeRates = item.interpretation_rates.filter(r => r.subject === subject);
                    } else if (selectedTemplate?.interpretation_rates) {
                        activeRates = selectedTemplate.interpretation_rates;
                    }
                    return activeRates; */}
                {(changeTemplate || item || selectedTemplate) &&
                    (() => {
                        const isReAdded = deletedSubjects.includes(subject?.value || subject);
                        let activeRates = [];
                        if (changeTemplate?.interpretation_rates) {
                            activeRates = changeTemplate.interpretation_rates;
                        } else if (!isReAdded && item?.interpretation_rates) {
                            activeRates = item.interpretation_rates.filter(r => r.subject === subject);
                        } else if (selectedTemplate?.interpretation_rates) {
                            activeRates = selectedTemplate.interpretation_rates;
                        }
                        return activeRates;
                })().map((val, index) => (
                    <div key={index} className='row-primary'>
                        <h2 className='fw-bold text-uppercase'>{val?.name || val?.tiers[0]?.name || 'N/A'}</h2>

                        <div>
                            <h2 className='text-center my-3 fw-bold fst-italic'>Normal Hours*</h2>

                            <div className='rate_container'>
                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Rates:</h2>
                                    <div className='Inter_rate_row'>
                                        <h4>OPI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_normal_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_normal_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>VRI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_normal_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_normal_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>In Person</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_normal_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_normal_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Minimum:</h2>
                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_normal_mins.${index}`} placeholder='OPI minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_normal_mins.${index}`} placeholder='VRI minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_normal_mins.${index}`} placeholder='In person minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h2 className='text-center my-3 fw-bold fst-italic'>After Hours*</h2>

                            <div className='rate_container'>
                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Rates:</h2>
                                    <div className='Inter_rate_row'>
                                        <h4>OPI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_after_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_after_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>VRI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_after_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_after_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>In Person</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_after_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_after_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Minimum:</h2>
                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_after_mins.${index}`} placeholder='OPI minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.opi_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_after_mins.${index}`} placeholder='VRI minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.vri_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_after_mins.${index}`} placeholder='In person minimun' />
                                            <UnitSelect control={control} name={`subjectConfigs.${subjectIndex}.interpretationRates.inperson_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default LanguageTiers